





























import ComponentInitializeDispatcher from '@owc-utils/Mixins/ComponentInitializeDispatcher';
import { LegalSection, LegalLink } from './Footer';
/**
 * `Legal Section Footer` - Legal Section Footer for OneWeb - Legal Section contains the legal information of the website, this components exists inside the Lower Footer Component
 */

export default ComponentInitializeDispatcher.extend({
  name: 'owc-legal-section',
  props: {
    datajson: {
      type: String,
      required: true,
    },
  },
  computed: {
    json: function(): LegalSection {
      return JSON.parse(this.datajson);
    },
    legalItems: function(): LegalLink[] {
      return this.json.items;
    },
    legalLicense: function(): LegalLink {
      return this.json.license;
    },
  },
});
